import { Component, OnInit } from '@angular/core';

import { map, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { LanguageService } from '@fcom/ui-translate/services/language.service';
import { RootPaths } from '@fcom/core/constants';
import { Profile } from '@fcom/core-api/login';
import { isCorporateAdmin, isCorporateAdminOrTravelBooker } from '@fcom/common/login';
import { finShare } from '@fcom/rx/operators/finShare';
import { ConfigService } from '@fcom/core/services';
import { AppState } from '@fcom/core/interfaces';
import { profile } from '@fcom/core/selectors';

@Component({
  selector: 'fin-corporate-navigation',
  templateUrl: './corporate-navigation.component.html',
  styleUrl: './corporate-navigation.component.scss',
})
export class CorporateNavigationComponent implements OnInit {
  profile$: Observable<Profile>;

  baseUrl: string;
  isAdminOrTravelBooker$: Observable<boolean>;
  isAdmin$: Observable<boolean>;
  enableCorporateSpend: boolean;

  constructor(
    private languageService: LanguageService,
    private configService: ConfigService,
    private store$: Store<AppState>
  ) {}

  ngOnInit(): void {
    this.baseUrl = `/${this.languageService.langValue}/${RootPaths.CORPORATE}`;
    this.profile$ = this.store$.pipe(profile(), finShare());
    this.isAdminOrTravelBooker$ = this.profile$.pipe(map(isCorporateAdminOrTravelBooker), take(1), finShare());
    this.isAdmin$ = this.profile$.pipe(map(isCorporateAdmin), take(1), finShare());
    this.enableCorporateSpend = this.configService.cfg.enableCorporateData;
  }
}
